/**
 * Required validation
 *
 * @param {any} value
 */
export function requiredValidation(value) {
    return value || value === 0 ? '' : 'validation.error.required';
}



// WEBPACK FOOTER //
// ./src/utils/requiredValidation.js